/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-01-03 13:36:03
 */

/**
 * é²æ­¢åæ³¡çå¼å®¹å¤ç
 * @param evt äºä»¶
 */
export function preventBubble(evt: any) {
  evt.stopPropagation ? evt.stopPropagation() : (evt.cancelBubble = true);
}
